<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
      v-model="items"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'sub_contractor_name')">
          {{ schema.fields.sub_contractor_name.label }}
        </th>
        <th v-if="canSee(schema, 'cost')">{{ schema.fields.cost.label }}</th>
        <th v-if="canSee(schema, 'bill_no')">
          {{ schema.fields.bill_no.label }}
        </th>
        <th v-if="canSee(schema, 'bill_date')">
          {{ schema.fields.bill_date.label }}
        </th>
        <th v-if="canSee(schema, 'is_declined')">
          {{ schema.fields.is_declined.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'sub_contractor_name')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="sub_contractor_name"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="sub_contractor_name"
              nolabel
              v-bind="schema.fields.sub_contractor_name"
              v-model="items[index].sub_contractor_name"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'cost')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="cost"
          >
            <o-text-field
              prepend="$"
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="cost"
              nolabel
              v-bind="schema.fields.cost"
              v-model="items[index].cost"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'bill_no')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="bill_no"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="bill_no"
              nolabel
              v-bind="schema.fields.bill_no"
              v-model="items[index].bill_no"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'bill_date')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="bill_date"
          >
            <o-date-time
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              hide-time
              name="bill_date"
              nolabel
              v-bind="schema.fields.bill_date"
              v-model="items[index].bill_date"
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'is_declined')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="is_declined"
          >
            <o-checkbox
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="is_declined"
              nolabel
              v-bind="schema.fields.is_declined"
              v-model="items[index].is_declined"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
      </template>
      <template v-if="items" slot="o-bottom-row">
        <td>Total Billed</td>
        <td>
          <o-text-field
            prepend="$"
            :form-state="formState"
            :server-errors="_se"
            name="total_billed"
            nolabel
            :value="total_billed(items)"
            readonly
          ></o-text-field>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";
import CrewSupplierMixin from "../../../mixins/CrewSupplierMixin";

export default {
  name: "ServiceRechargeBillToFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ServiceRechargeBillTo"),
    CreateCodeTableFetchMixin(["Supplier"]),
    CrewSupplierMixin(),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ServiceRechargeBillTo,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ServiceRechargeBillTo),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
    total_billed(items) {
      var result = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].cost) {
          result += parseFloat(items[i].cost);
        }
      }

      this.$emit("total_billed_change", result);
      return result.toFixed(2);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
